import { render, staticRenderFns } from "./banner-b1.vue?vue&type=template&id=19452f9b&scoped=true&"
import script from "./banner-b1.vue?vue&type=script&lang=js&"
export * from "./banner-b1.vue?vue&type=script&lang=js&"
import style0 from "./banner-b1.vue?vue&type=style&index=0&id=19452f9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19452f9b",
  null
  
)

export default component.exports